import * as tslib_1 from "tslib";
// Core components
import { OnDestroy, OnInit } from "@angular/core";
import { isArray } from "util";
// Third party components
import { MatDialog } from "@angular/material";
import { FieldType } from "@ngx-formly/material";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { finalize } from "rxjs/operators";
// Custom components
import { ConfigService } from 'src/app/shared/services/config.service';
import { FileService } from "src/app/shared/services/file.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { LightboxDialogComponent } from "../../dialogs/lightbox-dialog/lightbox-dialog.component";
var FileUploaderTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FileUploaderTypeComponent, _super);
    function FileUploaderTypeComponent(helperService, translateService, toastrService, fileService, configService, dialog) {
        var _this = _super.call(this) || this;
        _this.helperService = helperService;
        _this.translateService = translateService;
        _this.toastrService = toastrService;
        _this.fileService = fileService;
        _this.configService = configService;
        _this.dialog = dialog;
        _this.subscriptions = [];
        _this.triggerFileUpload = false;
        _this.triggerFileReset = false;
        _this.importFormSubmitBtnOptions = {
            active: false,
            text: _this.translateService.instant("common.cta.import"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            customClass: "mt-2"
        };
        _this.uploadedFiles = [];
        _this.fileIsUploading = false;
        /**
         * Uploads started and not ended yet. A file dropped while another upload is running starts a
         * second one, so a flag would end with the first: the count ends with the last. Only the page
         * that asks hears of it, @see notifyUploading
         */
        _this.uploadsInFlight = 0;
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    FileUploaderTypeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.formControl.value) {
            this.updateUpdatedFiles(this.formControl.value, false);
        }
        // Handle form values changes
        // this.subscriptions.push(
        //   this.formControl.valueChanges.subscribe(res => {
        //   })
        // );
        if (typeof this.to.allowedFilesNumber === "undefined") {
            this.to.allowedFilesNumber = 1;
        }
        if (typeof this.to.allowedFilesExtensions === "undefined") {
            this.to.allowedFilesExtensions = "*";
        }
        this.importFormSubmitBtnOptions.disabled = this.options.formState.disabled;
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    FileUploaderTypeComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    FileUploaderTypeComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.uploadedFiles = [];
        // An upload still reading its files has no subscription yet: nothing else would end it
        if (this.uploadsInFlight > 0) {
            this.uploadsInFlight = 0;
            this.notifyUploading(false);
        }
    };
    /**
     * Handle event "uploadFiles" emitted from file-uploader component
     *
     * @since 1.0.0
     *
     * @param files Files to upload
     * @returns undefined
     */
    FileUploaderTypeComponent.prototype.onUploadFiles = function (files) {
        var e_1, _a;
        var _this = this;
        if (this.options.formState.disabled) {
            console.warn('Block upload because field is disabled'); //@todo: translate
            return;
        }
        else {
            this.importFormSubmitBtnOptions.disabled = false;
        }
        this.importFormSubmitBtnOptions.active = true;
        this.fileIsUploading = true;
        this.uploadStarted();
        // You could upload it like this:
        var formData = new FormData();
        var counter = 1;
        var _loop_1 = function (givenFile) {
            var fileEntry = givenFile.fileEntry;
            fileEntry.file(function (file) {
                // const name = `file-${counter}`;
                var name = "file[]";
                formData.append(name, file, givenFile.relativePath);
                counter++;
                if (counter === files.length + 1) {
                    var uploadFilesSubscription = _this.fileService
                        .uploadImportingFiles(formData, _this.to.endpoint)
                        .pipe(finalize(function () {
                        _this.importFormSubmitBtnOptions.active = false;
                        // Every end passes here: answer, refusal, error, or the field destroyed
                        _this.uploadEnded();
                    }))
                        .subscribe(function (res) {
                        // Accept all-and-only last (this.to.allowedFilesNumber)
                        // files (this is need! do not remove!)
                        if (res.status) {
                            var files_2 = [];
                            if (_this.to.endpoint && _this.to.endpoint === 'supplier') {
                                files_2 = res.data.slice(-_this.to.allowedFilesNumber);
                            }
                            else {
                                files_2 = res.files.slice(-_this.to.allowedFilesNumber);
                            }
                            res.files = files_2;
                        }
                        // If available, call the callback
                        if (typeof _this.to.callback === "function") {
                            _this.to.callback(res, _this.model);
                        }
                        // Handle res status
                        if (res.status) {
                            _this.triggerFileReset = !_this.triggerFileReset; // Reset drop-zone area
                            _this.updateUpdatedFiles(res.files, true);
                            _this.fileIsUploading = false;
                            return;
                        }
                        if (res.message) {
                            _this.toastrService.error(_this.translateService.instant("common.words.warning"), res.message);
                            _this.fileIsUploading = false;
                            return;
                        }
                        _this.fileIsUploading = false;
                        _this.toastrService.error(_this.translateService.instant("common.errors.unknown"));
                    }, function (err) {
                        // Choose one of the following error handling
                        // method. The first one show a message right
                        // under the form fields (if the form is properly
                        // setted), the second one show toastr
                        // notifications for each error
                        // this.helperService.handleFormError(this.form, err);
                        _this.helperService.handleError(err);
                        _this.fileIsUploading = false;
                    });
                    _this.subscriptions.push(uploadFilesSubscription);
                }
            });
        };
        try {
            for (var files_1 = tslib_1.__values(files), files_1_1 = files_1.next(); !files_1_1.done; files_1_1 = files_1.next()) {
                var givenFile = files_1_1.value;
                _loop_1(givenFile);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (files_1_1 && !files_1_1.done && (_a = files_1.return)) _a.call(files_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * An upload starts: the page that asked is told on the first one only.
     *
     * @since 3.0.0
     */
    FileUploaderTypeComponent.prototype.uploadStarted = function () {
        this.uploadsInFlight++;
        if (this.uploadsInFlight === 1) {
            this.notifyUploading(true);
        }
    };
    /**
     * An upload ended, however it ended. The page that asked is told when the last one ends, after
     * the answer has put the files in the field.
     *
     * @since 3.0.0
     */
    FileUploaderTypeComponent.prototype.uploadEnded = function () {
        // An upload that outlived its field: the destroy already said it was over
        if (this.uploadsInFlight === 0) {
            return;
        }
        this.uploadsInFlight--;
        if (this.uploadsInFlight === 0) {
            this.notifyUploading(false);
        }
    };
    /**
     * Tell the page whether a file is still on its way, when it asked with
     * `templateOptions.uploadingChange`. The option is only read, never written: the pages that do
     * not pass it, and the form configs stored elsewhere, see the uploader exactly as before.
     *
     * @since 3.0.0
     */
    FileUploaderTypeComponent.prototype.notifyUploading = function (uploading) {
        if (typeof this.to.uploadingChange === "function") {
            this.to.uploadingChange(uploading);
        }
    };
    /**
     * Absolute URL of an uploaded file for the "open in new tab" link.
     * updateUpdatedFiles() already prefixes the API host to file.path, so the host
     * must not be prepended again; Windows-style separators are normalised.
     *
     * @since 3.0.0
     */
    FileUploaderTypeComponent.prototype.getFileUrl = function (file) {
        var rawPath = file && typeof file.path === 'string' ? file.path.replace(/\\/g, '/') : '';
        if (/^https?:\/\//i.test(rawPath)) {
            return rawPath;
        }
        var apiHost = this.to.endpoint && this.to.endpoint === 'supplier'
            ? this.configService.apiSuppliersHost
            : this.configService.apiHost;
        return apiHost + "/" + rawPath.replace(/^\/+/, '');
    };
    /**
     * Update current updatedFiles
     *
     * @since 1.0.0
     */
    FileUploaderTypeComponent.prototype.updateUpdatedFiles = function (files, setValue) {
        var _this = this;
        if (setValue === void 0) { setValue = false; }
        // let apiHost = environment.apiProtocol + environment.apiHost;
        // if (environment.apiPort !== "" && environment.apiHost !== "80") {
        //   apiHost += `:${environment.apiPort}`;
        // }
        var apiHost = this.configService.apiHost;
        if (this.to.endpoint && this.to.endpoint === 'supplier') {
            apiHost = this.configService.apiSuppliersHost;
        }
        // Update image previews list
        if (files) {
            files.forEach(function (file) {
                var path = file.path;
                // if (path.startsWith("public")) {
                if (path.substring(0, apiHost.length) !== apiHost) {
                    var newPath = apiHost + "\\" + path;
                    file.path = newPath;
                }
                // }
                _this.uploadedFiles.push(file);
            });
            // Prevent visualization of more previews than allowed
            this.uploadedFiles = this.uploadedFiles.slice(-this.to.allowedFilesNumber);
            if (setValue) {
                this.value = this.uploadedFiles;
            }
        }
    };
    /**
     * Remove given item from:
     * 1) File previews
     * 2) Field's value
     *
     * @since 1.0.0
     */
    FileUploaderTypeComponent.prototype.onRemove = function (file) {
        // Remove file from previews
        this.uploadedFiles = this.uploadedFiles.filter(function (item) { return item._id !== file._id; });
        var key = this.key;
        // Remove file from field value
        if (typeof file._id !== "undefined" && this.model[key] === file._id) {
            this.model[key] = null;
        }
        if (isArray(this.model[key])) {
            this.model[key] = this.model[key].filter(function (item) { return item._id !== file._id; });
        }
    };
    /**
     * Handle click on a image preview and opens it in a dialog
     *
     * @since 1.0.0
     */
    FileUploaderTypeComponent.prototype.onOpenImage = function (file) {
        this.dialog.open(LightboxDialogComponent, {
            data: {
                url: file.path
            },
            panelClass: "lightbox-dialog"
        });
    };
    /**
     * Transform given size in bytes to
     * a kb string
     *
     * @since 1.0.0
     *
     * @param size The size to transform
     * @return Transformed size string with 2 decimals
     */
    FileUploaderTypeComponent.prototype.getFormattedSize = function (size) {
        var sizeInKb = size / 1024;
        return sizeInKb.toFixed(2);
    };
    return FileUploaderTypeComponent;
}(FieldType));
export { FileUploaderTypeComponent };
